// 콩팥병 형태 선택 컴포넌트

import { Form, Input } from 'antd';
import { useImmerAtom } from 'jotai-immer';
import { useAtomValue } from 'jotai';
import styled from 'styled-components';
import { isLowsaltInputAtom, kidneyAtom } from './atom';
import { useHandleEventValue } from './hooks';
import { RelayionTypeSection } from './styled';

const LowSaltStringInput = ({ getFieldDecorator, inputMessage }) => {
  const isLowsaltInput = useAtomValue(isLowsaltInputAtom);
  const [, setKidney] = useImmerAtom(kidneyAtom);
  const handleChangeValue = useHandleEventValue({ setImmerState: setKidney });

  if (!isLowsaltInput) return null;
  return (
    <Form.Item>
      {getFieldDecorator('causesLowSaltInput', {
        rules: [
          {
            required: true,
            message: inputMessage
          }
        ]
      })(
        <BornYearSection>
          <SubQueryTitle>기타 질환을 입력해주세요</SubQueryTitle>
          <InputBox name="causesLowSaltInput" onChange={handleChangeValue('causesLowSaltInput')} placeholder="예: 콩팥질환" />
        </BornYearSection>
      )}
    </Form.Item>
  );
};

export default LowSaltStringInput;

const InputBox = styled(Input)`
  width: 60%;
  height: 6rem;
  line-height: 6rem;
  font-size: 1.8rem;
  margin-bottom: 1rem;
  input::placeholder {
    font-size: 1.8rem;
  }
  ${props => props.theme.device.md} {
    font-size: 2.4rem;
    height: 7.2rem;
    line-height: 7.2rem;
    input::placeholder {
      font-size: 2.4rem;
    }
  }
`;
const SubQueryTitle = styled.div`
  word-break: keep-all;
  font-size: 1.8rem;
  font-weight: 400;
  color: #323232;
  margin-bottom: ${props => (props.isText ? '0' : '2rem')};

  ${props => props.theme.device.md} {
    font-size: 2rem;
  }
`;

const BornYearSection = styled(RelayionTypeSection)``;
